import React from "react";
import "./onlinePendingLogHeader.scss";
import moment from "moment";
import { APPLICABLE_ROLE, PENDING_HEADER_LIST_TITLE } from "../../constant";
import TitleSubtitleCard from "../../../common/Modules/TitleSubtitleCard";
import { USER_ROLE } from "../../../../Util/constants";

export default function OnlinePendingLogsCell(props) {
  const getClassName = (obj) => {
    let name = "col-md-2";

    if (obj === PENDING_HEADER_LIST_TITLE.DATETIME) {
      name = "col-md-2 p-2";
    } else if (obj === PENDING_HEADER_LIST_TITLE.DOCTORNAME) {
      name = "col-md-2 p-1";
    } else if (obj === PENDING_HEADER_LIST_TITLE.PATIENTDETAILS) {
      name = "col-md-2 p-0";
    } else if (obj === PENDING_HEADER_LIST_TITLE.PROCEDURE) {
      name = "col-md-2  p-0";
    } else if (obj === PENDING_HEADER_LIST_TITLE.PAYMENTMETHOD) {
      name = "col-md-2 p-0";
    } else if (obj === "" || obj === PENDING_HEADER_LIST_TITLE.STATUS || obj === PENDING_HEADER_LIST_TITLE.ACTION) {
      name =
        props.user_type === APPLICABLE_ROLE.STAFF ||
          props.doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          props.doctorRole === USER_ROLE.RESOURCE_ADMIN
          ? "col-md-1 p-0"
          : "col-md-2 p-0";
    }
    return name;
  };

  function renderAppointmentType(type) {
    switch (type) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  }

  function renderPendingStatus(type) {
    switch (type) {
      case "success":
        return <div className="remarks-status-successful">success</div>;
      case "pending":
        return <div className="remarks-status-pending">pending</div>;
      case "failed":
        return <div className="remarks-status-failure">failed</div>;
      default:
        return "";
    }
  }

  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (consultationType) {
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "instant":
        return <span>Instant</span>;
      default:
        return "";
    }
  }

  function editAppointment() {
    props.editCallback(props.appointment);
  }

  function deleteAppointment() {
    props.deleteCallback(props.appointment);
  }

  const getAppointmentTitle = () => {
    const { appointment_type, payment_method } = props.appointment;
    if (appointment_type === "in-clinic" && payment_method === "online") {
      return "Online";
    } else if (appointment_type === "online" && payment_method === "online") {
      return "Online";
    } else if (appointment_type === "instant") {
      if (payment_method === "online") {
        return "Online";
      } else {
        return payment_method;
      }
    } else {
      return "NA";
    }
  };

  const createTableCellUI = () => {
    return (
      <div className="row appointment-row py-2 d-lg-flex d-none align-items-center">
        <div
          className={
            getClassName(PENDING_HEADER_LIST_TITLE.DATETIME) +
            " online-pending-cells-datetime"
          }
        >
          <TitleSubtitleCard
            title={moment(props.appointment.appointment_date).format(
              "MMM DD, YYYY"
            )}
            subtitle={moment(props.appointment.start_time, "hh:mm a").format(
              "hh:mm A"
            )}
          />
        </div>
        {(props.user_type === APPLICABLE_ROLE.STAFF ||
          props.doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          props.doctorRole === USER_ROLE.RESOURCE_ADMIN) && (
            <div
              className={
                getClassName(PENDING_HEADER_LIST_TITLE.DOCTORNAME) +
                " online-pending-cells-doctor-name"
              }
            >
              <TitleSubtitleCard title={props.appointment.doctor_name} />
            </div>
          )}

        <div
          className={
            getClassName(PENDING_HEADER_LIST_TITLE.PATIENTDETAILS) +
            " online-pending-cells-patient-details"
          }
        >
          <TitleSubtitleCard
            title={props.appointment.patient_name}
            subtitle={props.appointment.patient_phone_no}
          />
        </div>

        <div
          className={
            getClassName(PENDING_HEADER_LIST_TITLE.PROCEDURE) +
            " online-pending-cells-consultation-type"
          }
        >
          <TitleSubtitleCard
            title={renderAppointmentType(props.appointment.appointment_type)}
            subtitle={renderConsultationType(
              props.appointment.appointment_type,
              props.appointment.consultation_type,
              props.appointment.procedure_name
            )}
          />
        </div>
        <div
          className={
            getClassName(PENDING_HEADER_LIST_TITLE.PAYMENTMETHOD) +
            " online-pending-cells-payment-method"
          }
        >
          <TitleSubtitleCard
            title={
              getAppointmentTitle()
            }
          />
        </div>
        <div
          className={
            getClassName(PENDING_HEADER_LIST_TITLE.STATUS) +
            " online-pending-cells-status"
          }
        >
          <TitleSubtitleCard
            title={renderPendingStatus(props.appointment.status)}
          />
        </div>
        <div
          className={
            getClassName(PENDING_HEADER_LIST_TITLE.ACTION) +
            " online-pending-cells-action-icon"
          }
        >
          {props.appointment.status === "pending" && (
            <>
              <img
                src={require("../../../../assets/Layer 2.svg")}
                alt=""
                onClick={editAppointment}
                className="online-pending-cells-action-icon-edit"
              />
              <img
                src={require("../../../../assets/deleteiconNew.svg")}
                alt=""
                onClick={deleteAppointment}
                className="online-pending-cells-action-icon-delete"
              />
            </>
          )}
        </div>
      </div>
    );
  };


  const createTableCellMobileUI = () => {
    return (
      <div
        className="row appointment-row d-lg-none d-flex align-items-center"
        style={{
          paddingTop: "0.5rem",
          paddingBottom: props.appointment.status !== "pending" ? "" : "0",
        }}
      >
        <div className="row w-100 m-0">
          <div className="col-6">
            <p className="header m-0 mb-1">DATE &amp; TIME</p>
            <TitleSubtitleCard
              title={moment(props.appointment.appointment_date).format(
                "MMM DD, YYYY"
              )}
              subtitle={moment(props.appointment.start_time, "hh:mm a").format(
                "hh:mm A"
              )}
            />
          </div>
          <div className="col-6">
            <p className="header m-0 mb-1">PATIENT DETAILS</p>
            <TitleSubtitleCard
              title={props.appointment.patient_name}
              subtitle={props.appointment.patient_phone_no}
            />
          </div>
        </div>
        <div className="row w-100 m-0 mt-3">
          <div className="col-6">
            <p className="header m-0 mb-1">PROCEDURE</p>
            <TitleSubtitleCard
              title={renderAppointmentType(props.appointment.appointment_type)}
              subtitle={renderConsultationType(
                props.appointment.appointment_type,
                props.appointment.consultation_type,
                props.appointment.procedure_name
              )}
            />
          </div>
          <div className="col-6">
            <p className="header m-0 mb-1">PAYMENT METHOD</p>
            <TitleSubtitleCard
              title={getAppointmentTitle()}
            />
          </div>
        </div>
        <div
          className="row w-100 m-0 mt-3"
          style={{
            paddingBottom: props.appointment.status === "pending" ? "15px" : "",
          }}
        >
          <div className="col-6">
            <p className="header m-0 mb-1">DOCTOR NAME</p>
            <TitleSubtitleCard title={props.appointment?.doctor_name} />
          </div>
          <div className="col-6">
            <p className="header m-0 mb-1">STATUS</p>
            <TitleSubtitleCard
              title={renderPendingStatus(props.appointment.status)}
            />
          </div>
        </div>

        {props.appointment.status === "pending" && (
          <div className="row w-100 m-0 online-pending-cells-mobile-view-icons">
            <div
              onClick={editAppointment}
              className="col-6 p-0 online-pending-cells-mobile-view-icons-edit"
            >
              <img src={require("../../../../assets/Layer 2.svg")} alt="" />
              Edit Details
            </div>
            <div
              onClick={deleteAppointment}
              className="col-6 online-pending-cells-mobile-view-icons-delete"
            >
              <img
                src={require("../../../../assets/Icon_delete_solid.svg")}
                alt=""
              />
              Delete
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="online-pending-log-cells">
      <>
        {createTableCellUI()}
        {createTableCellMobileUI()}
      </>
    </div>
  );
}
